/**
 * Questions Collection
 */
define('Question.Collection', [
      'SCCollection'
    , 'underscore'
    , 'Utils'
    , 'Question.Model'
  ],
  function(
      SCCollectionModule
    , _
    , Utils
    , QuestionModel
  ) {

    'use strict';

    var SCCollection = SCCollectionModule.SCCollection;

    function QuestionCollection(models, options) {
      SCCollection.call(this, models, options);
      this.url = function () {
          return Utils.getAbsoluteUrl(getExtensionAssetsPath('Modules/QAndA/SuiteScript2/Tavano.QAndA.Service.ss'),true)
      }
      var params = {
        id: options.itemid,
        page: options.page || 0
      }
      this.params = params
    }

    QuestionCollection.prototype = Object.create(SCCollection.prototype);
    QuestionCollection.prototype.constructor = QuestionCollection;

    return QuestionCollection
  })
